/**
 * Marcador devolvido pelas actions de consulta de CPF quando não há passe de
 * humanidade válido.
 *
 * É retorno, e não exceção, porque erro lançado de uma Server Action chega ao
 * cliente sanitizado em produção: vira mensagem genérica com digest, e o
 * formulário não teria como distinguir "sem passe" de qualquer outra falha —
 * ficaria sem saber que basta pedir um novo desafio.
 *
 * Também não é retorno vazio de propósito: devolver "não encontrado" faria o
 * formulário seguir para o cadastro e poderia criar conta duplicada para quem
 * já existe.
 */
export const HUMAN_PASS_REQUIRED_CODE = 'human-pass-required' as const;

export const HUMAN_PASS_REQUIRED_MESSAGE =
  'Precisamos confirmar que você não é um robô. Tente novamente em instantes.';

export type HumanPassDenied = {
  success: false;
  code: typeof HUMAN_PASS_REQUIRED_CODE;
  error: string;
};

export const humanPassDenied = (): HumanPassDenied => ({
  success: false,
  code: HUMAN_PASS_REQUIRED_CODE,
  error: HUMAN_PASS_REQUIRED_MESSAGE,
});

/**
 * Reconhece a negativa em qualquer retorno de action.
 *
 * O formato casa com o que `checkCpfRegistrationStatus` já devolvia, então um
 * único predicado serve para as quatro actions protegidas.
 */
export const isHumanPassDenied = (value: unknown): value is HumanPassDenied =>
  typeof value === 'object' &&
  value !== null &&
  (value as { code?: unknown }).code === HUMAN_PASS_REQUIRED_CODE;
